import type { KeenSliderInstance } from 'keen-slider'
import range from 'lodash/range'
import type { FunctionComponent, MutableRefObject } from 'react'
import { useEffect, useRef } from 'react'
import type { KeenSliderOptionTypes } from '../hooks/useResponsiveStackGridOptions'
import { useIsSmOrGreater } from '../hooks/useWindowSize'
import type { Slide } from './AccentroSlider'

const sliderBarClasses = (active?: boolean) =>
  [
    'border-2',
    'm-px-4',
    'relative',
    'rounded-none',
    'h-px-80',
    'w-px-80',
    'flex-shrink-0',
    'text-xs',
    'sm:h-px-96',
    'sm:w-px-96',
    'sm:border-4',
    active ? 'border-accentroWhite-full' : 'border-transparent',
  ].join(' ')

const sliderBarContainerBaseClass =
  'flex justify-start flex-nowrap overflow-auto'
const sliderBarContainerScrollbarStyle: React.CSSProperties = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}

export const SliderBottomNavigationWithPreview: FunctionComponent<
  React.PropsWithChildren<{
    thumbnails?: Slide[]
    slider: MutableRefObject<KeenSliderInstance | null>
    optionType: KeenSliderOptionTypes
    slidesPerView: number
    slideIndex: number
    isArticle?: boolean
  }>
> = ({ slider, slidesPerView, slideIndex, optionType, thumbnails }) => {
  const sliderKeys =
    slider && slider.current
      ? range(slider.current.track.details.slides.length)
      : []

  const containerRef = useRef<HTMLDivElement | null>(null)
  const isSmOrGreater = useIsSmOrGreater()
  const scrollToRef = () => {
    if (!containerRef.current) return

    const offset = isSmOrGreater ? 96 : 48
    //scroll into view does not work here because it also scrolls vertically which we do not want and its not able to disable it
    const containerRect = containerRef.current.getBoundingClientRect()
    // calc the width of each thumbnail - 96 is the offset which gets added by the grid and scrollwidth does not respect that its not part of its container ._.
    const unitWidth =
      (containerRef.current.scrollWidth - offset) / sliderKeys.length

    //calc the offset to the center of box
    const center = (containerRect.width - offset) / 2 + unitWidth / 2
    // console.log({
    //   unitWidth,
    //   sw: containerRef.current.scrollWidth,
    //   keyslength: sliderKeys.length,
    //   left: unitWidth * (slideIndex + 1) - center,
    //   center,
    //   containerRect,
    // })

    //scroll left the amount of the units times their width, then minus the center offset so it scrolls the current thumbnail into center of box
    containerRef.current.scrollTo({
      behavior: 'smooth',
      left: unitWidth * (slideIndex + 1) - center,
    })
    // console.log({ center, unitWidth, slideIndex })
  }
  useEffect(() => {
    scrollToRef()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideIndex])
  return (
    <div
      ref={containerRef}
      className={sliderBarContainerBaseClass}
      style={sliderBarContainerScrollbarStyle}
    >
      {/* Hide scrollbar (WebKit) */}
      <style>{`div::-webkit-scrollbar { display: none; }`}</style>
      {sliderKeys.map((idx) => {
        if (idx >= sliderKeys.length - Math.round(slidesPerView) + 1)
          return null
        const active = slideIndex === idx
        return (
          <button
            key={idx}
            className={sliderBarClasses(active)}
            onClick={() => slider.current?.moveToIdx(idx)}
          >
            {thumbnails?.[idx].slide}
          </button>
        )
      })}
    </div>
  )
}
